class CommonHelper {
  static moveByIdToFirstPosition(arr, id) {
    const index = arr.findIndex(item => item.id === id);
    if (index !== -1) {
      // Sacar el objeto del array
      const [objeto] = arr.splice(index, 1);
      // Insertarlo al principio del array
      arr.unshift(objeto);
    }
    return arr;
  }
}

export { CommonHelper };



// WEBPACK FOOTER //
// ./src/helpers/CommonHelper.js